import(/* webpackMode: "eager" */ "/vercel/path0/volya-frontend/app/error.tsx");
